/**
 * @file 페이지 export 함수 모듈
 */

/**
 * isEmpty 빈값인지 체크
 * @param {string} value value (!value 하면 생기는 논리적 오류를 제거하기 위해 명시적으로 value == 사용)
 * @returns {boolean}
 */
export const isEmpty = value => {
    if (
        value === '' ||
        value === null ||
        value === undefined ||
        (value !== null && typeof value == 'object' && !Object.keys(value).length)
    ) {
        return true
    } else {
        return false
    }
}

export const nullCheck = data => {
    let result
    isEmpty(data) ? (result = '') : (result = data)

    return result
}

/*
 * obj 값이 비었는지 확인
 * @constant obj obj 값
 */
export function isEmptyObj(obj) {
    if (obj.constructor === Object && Object.keys(obj).length === 0) {
        return true
    }
    return false
}

/**
 * 빈값일때 원하는 값으로 변환하여 return 하는 함수
 * @param {*} data 들어오는 데이터값
 * @param {*} value null 일때 리턴할값
 * @returns 데이터 값이 빈값이면 '원하는값' 으로 리턴시킨다
 */
export const nullReturn = (data, value) => {
    let result
    isEmpty(data) ? (result = value) : (result = data)

    return result
}

/**
 * isOnlySpace 공백만 있는 텍스트인지 체크
 * @param {string} value value
 * @returns {boolean}
 */
export const isOnlySpace = value => {
    return value.trim().length === 0
}

/**
 * 숫자만 입력가능
 * @param {string} asValue 텍스트
 * @returns 일치시 true
 */
export const onlyNum = asValue => {
    let text = asValue.replace(/[^0-9]/g, '')

    return text
}

/**
 * 한글, 소문자, 숫자만 입력가능
 * @param {string} asValue 텍스트
 * @returns 일치시 true
 */
export const onlyKorLowEngNum = asValue => {
    let text = asValue.replace(/[^ㄱ-ㅎㅏ-ㅣ가-힣a-z0-9ㆍᆢ]/g, '')

    return text
}

/**
 * 한글, 영문, 숫자, 일부기호, 띄어쓰기만 입력가능
 * @param {string} asValue 텍스트
 * @returns 일치시 true
 */
export const onlyKorEngNumSym = asValue => {
    //let text = asValue.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9-_./~]/g, '')
    let text = asValue.replace(/[^\s\dㄱ-ㅎㅏ-ㅣ가-힣a-zA-Z0-9ㆍᆢ_\./~]/g, '')

    return text
}

/**
 * 1~50자 / 한글,영문,숫자 가능
 * @param {string} asValue 성명
 * @returns 일치시 true
 */
export const isNameInvalid = asValue => {
    let regExp = /^[ㄱ-ㅎㅏ-ㅣ가-힣a-z0-9ㆍᆢ]{1,50}$/g
    let isTrue = regExp.test(asValue)

    return isTrue
}

/**
 * 이메일 (1~50자리)@(1~49자리)
 * @param {string} asValue 이메일
 * @returns 일치시 true
 */
export const isEmailInvalid = asValue => {
    let regExp = /^[a-zA-Z0-9._%+-]{1,50}@[a-zA-Z0-9#?!@$%^&*()-_.]+\.[a-zA-Z0-9#?!@$%^&*()-_.]{1,49}$/g
    let isTrue

    isTrue = regExp.test(asValue)

    return isTrue
}

/**
 * 상세주소 길이(0~50자)
 * @param {string} asValue 상세주소
 * @returns 일치시 true
 */
export const isDetailAddressInvalid = asValue => {
    let isTrue = asValue.length < 51

    return isTrue
}

//휴대폰번호 하이픈
export const hyphenNumber = phoneNumber => {
    //const phoneNumber = '01012345678'; // 또는 '01012345678'
    let formattedPhoneNumber = phoneNumber.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-$3')

    if (phoneNumber.length === 10) {
        return (formattedPhoneNumber = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'))
    } else if (phoneNumber.length === 11) {
        return (formattedPhoneNumber = phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3'))
    }
    return phoneNumber
}

/**
 * 쉼표 앞의 텍스트를 가져오는 것
 * @param {string} text text
 * @returns {string} beforeComma
 */
export const beforeComma = text => {
    let commaIndex = text.indexOf(',')
    let beforeComma = commaIndex !== -1 ? text.split(',')[0] : text

    return beforeComma
}

/********************  금액 관련 함수 ********************/
/**
 * 숫자 3자리마다 콤마
 * @param {number} price 금액
 * @returns 숫자 3자리마다 콤마 찍힌 금액
 */
export const priceToString = price => {
    if (price === 0 || price === '0') {
        return '0'
    }

    if (isEmpty(price)) {
        return ''
    }

    const priceString = price.toString()
    let resultPrice = ''

    for (let i = 0; i < priceString.length; i++) {
        if (i !== 0 && (priceString.length - i) % 3 === 0) {
            resultPrice += ','
        }
        resultPrice += priceString.charAt(i)
    }

    return resultPrice
}
